import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import LOGO from '../assets/NYD-logo-footer.svg';
import { useAuth } from '../context/AuthContext';

const ALLOWED_REDIRECT_DOMAINS = ['nocheydiaturismo.com', 'travelsale.nocheydiaturismo.com', 'reservas.nocheydiaturismo.com', 'reservas.opcionesargentinas.com'];
function isSafeRedirectUrl(url) {
  try { return ALLOWED_REDIRECT_DOMAINS.includes(new URL(url).hostname); } catch { return false; }
}

function Navbar({ activeLink }) {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();

  return (
    <nav className="absolute w-full z-[100] text-white py-3 px-6">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo - MEJORADO */}
          <Link to="/" className="flex items-center group -ml-5">
            <img
              src={LOGO}
              alt="Noche y Día Turismo"
              className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center space-x-6">
          <Link 
            to="/paquetes" 
            className={`text-lg font-semibold transition-colors duration-300 ${
              activeLink === 'paquetes' 
                ? 'text-white' 
                : 'text-white hover:text-[#ff681f]'
            }`}
          >
            Paquetes
          </Link>
          <Link 
            to="/contacto" 
            className={`text-lg font-semibold transition-colors duration-300 ${
              activeLink === 'contacto' 
                ? 'text-[#ff681f]' 
                : 'text-white hover:text-[#ff681f]'
            }`}
          >
            Contacto
          </Link>
          {/*
          <Link 
            to="/travel-sale" 
            className={`text-lg font-semibold transition-colors duration-300 ${
              activeLink === 'travel-sale' 
                ? 'text-[#ff681f]' 
                : 'text-white hover:text-[#ff681f]'
            }`}
          >
            TravelSale
          </Link>
          */}

          <Link 
            to="/paginas/condiciones-generales" 
            className="text-lg font-semibold text-white hover:text-[#ff681f] transition-colors duration-300"
          >
            Condiciones Generales
          </Link>

          <Link 
            to="/preguntas-frecuentes" 
            className="text-lg font-semibold text-white hover:text-[#ff681f] transition-colors duration-300"
          >
            Preguntas Frecuentes
          </Link>
          
          {/* Dropdown Información */}
          <div className="relative">
            <button 
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-1 text-lg font-semibold text-white hover:text-[#ff681f] transition-colors duration-300"
            >
              Información
              <ChevronDown 
                size={18} 
                className={`transition-transform duration-300 ${dropdownOpen ? 'rotate-180' : ''}`} 
              />
            </button>
            
            {dropdownOpen && (
              <>
                <div 
                  className="fixed inset-0 z-10"
                  onClick={() => setDropdownOpen(false)}
                />
                
                <div className="absolute top-full left-0 mt-2 w-64 bg-white text-gray-800 rounded-xl shadow-2xl border border-gray-100 py-2 z-20">
                  <Link
                    to="/paginas/informacion-general"
                    className="block px-5 py-3 hover:bg-gray-50 transition-colors hover:text-[#ff681f]"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <div className="font-semibold text-gray-800">Informacion General</div>
                    <div className="text-xs text-gray-500 mt-1">Términos de contratación</div>
                  </Link>
                  <Link
                    to="/paginas/medios-de-pago"
                    className="block px-5 py-3 hover:bg-gray-50 transition-colors hover:text-[#ff681f]"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <div className="font-semibold text-gray-800">Medios de Pago</div>
                    <div className="text-xs text-gray-500 mt-1">Opciones de pago disponibles</div>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Desktop Actions */}
        <div className="hidden lg:flex items-center space-x-2">
          {isAuthenticated ? (
            <>
              <span className="text-sm font-medium drop-shadow whitespace-nowrap">Hola, {user?.name}</span>
              <button
                onClick={async () => {
                  try {
                    const token = localStorage.getItem('token');
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/mis-reservas-redirect`, {
                      headers: { 'Authorization': `Bearer ${token}` }
                    });
                    const data = await response.json();
                    if (data.success && isSafeRedirectUrl(data.redirectUrl)) {
                      window.location.href = data.redirectUrl;
                    }
                  } catch (error) {
                    console.error('Error:', error);
                    alert('Error al acceder a tus reservas');
                  }
                }}
                className="text-sm text-white font-semibold hover:text-[#ff681f] transition-colors duration-300 whitespace-nowrap"
              >
                Mis Reservas
              </button>
              <button
                onClick={logout}
                className="bg-[#ff681f] text-white text-sm font-semibold rounded-full px-4 py-2 hover:bg-[#e05510] transition-colors duration-300 whitespace-nowrap"
              >
                Cerrar Sesión
              </button>
              {user?.role === 'admin' && (
                <Link
                  to="/admin"
                  className="bg-[#FFD166] text-gray-800 text-sm font-semibold rounded-full px-4 py-2 hover:bg-[#F4A261] transition-colors duration-300 whitespace-nowrap"
                >
                  Admin
                </Link>
              )}
            </>
          ) : (
            <>
              <Link 
                to="/login" 
                className="text-lg font-semibold hover:text-[#ff681f] transition-colors drop-shadow"
              >
                Inicia Sesión
              </Link>

              <Link 
                to="/login?mode=register" 
                className="bg-[#ff681f] text-white font-semibold rounded-full px-6 py-3 text-center hover:bg-[#e05510] transition-colors w-full max-w-xs"
                onClick={() => setIsOpen(false)}
              >
                Registrate
              </Link>
            </>
          )}
          <button className="text-white font-semibold hover:text-[#ff681f] transition-colors drop-shadow">
            ES
          </button>
        </div>

        {/* Mobile Menu Button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className={`lg:hidden z-[110] transition-colors ${
                isOpen ? 'text-white hover:text-[#ff681f]' : 'text-white hover:text-[#ff681f]'
              }`}
            >
              {isOpen ? <X size={32} /> : <Menu size={32} />}
            </button>
        </div>
              
        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden fixed inset-0 bg-[#1E3A5F] bg-opacity-98 z-40 pt-24 overflow-y-auto">
            <div className="container mx-auto px-6 py-8">
              <div className="flex flex-col space-y-6 text-white items-center"> {/* ← AGREGADO items-center */}
                <Link 
                  to="/paquetes" 
                  className="text-xl font-semibold hover:text-[#ff681f] transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Paquetes
                </Link>
                <Link 
                  to="/contacto" 
                  className="text-xl font-semibold hover:text-[#ff681f] transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Contacto
                </Link>
                {/* 
                <Link 
                  to="/travel-sale" 
                  className="text-xl font-semibold hover:text-[#ff681f] transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  TravelSale
                </Link>
                */}

                <Link 
                  to="/paginas/condiciones-generales" 
                  className="text-xl font-semibold hover:text-[#ff681f] transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Condiciones Generales
                </Link>

                <Link 
                  to="/preguntas-frecuentes" 
                  className="text-xl font-semibold hover:text-[#ff681f] transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Preguntas Frecuentes
                </Link>
                
                <div className="border-t border-white/20 pt-6 mt-4 w-full"> {/* ← AGREGADO w-full */}
                  <div className="text-sm text-gray-300 uppercase font-bold mb-4 tracking-wider text-center"> {/* ← AGREGADO text-center */}
                    Información
                  </div>
                  <div className="flex flex-col items-center space-y-4"> {/* ← AGREGADO items-center */}
                    <Link 
                      to="/paginas/informacion-general" 
                      className="text-lg font-semibold hover:text-[#ff681f] transition-colors"
                      onClick={() => setIsOpen(false)}
                    >
                      Informacio General
                    </Link>
                    <Link 
                      to="/paginas/medios-de-pago" 
                      className="text-lg font-semibold hover:text-[#ff681f] transition-colors"
                      onClick={() => setIsOpen(false)}
                    >
                      Medios de Pago
                    </Link>
                  </div>
                </div>

                <div className="border-t border-white/20 pt-6 mt-4 flex flex-col space-y-4 w-full items-center"> {/* ← AGREGADO items-center */}
                  {isAuthenticated ? (
                    <>
                      <div className="text-center py-2">
                        <span className="text-lg font-medium">Hola, {user?.name}</span>
                      </div>
                      <button
                        onClick={async () => {
                          try {
                            const token = localStorage.getItem('token');
                            const response = await fetch(`${process.env.REACT_APP_API_URL}/mis-reservas-redirect`, {
                              headers: { 'Authorization': `Bearer ${token}` }
                            });
                            const data = await response.json();
                            if (data.success) {
                              window.location.href = data.redirectUrl;
                            }
                          } catch (error) {
                            console.error('Error:', error);
                            alert('Error al acceder a tus reservas');
                          }
                        }}
                        className="text-xl font-semibold hover:text-[#ff681f] transition-colors"
                      >
                        Mis Reservas
                      </button>
                      <button
                        onClick={() => {
                          logout();
                          setIsOpen(false);
                        }}
                        
                        className="bg-[#ff681f] text-white font-semibold rounded-full px-6 py-3 text-center hover:bg-[#e05510] transition-colors w-full max-w-xs"
                      >
                        Cerrar Sesión
                      </button>
                      {user?.role === 'admin' && (
                        <Link
                          to="/admin"
                          className="bg-[#FFD166] text-gray-800 font-semibold rounded-full px-6 py-3 text-center hover:bg-[#F4A261] transition-colors w-full max-w-xs"
                          onClick={() => setIsOpen(false)}
                        >
                          Admin
                        </Link>
                      )}
                    </>
                  ) : (
                    <>
                      <Link 
                        to="/login" 
                        className="text-xl font-semibold hover:text-[#ff681f] transition-colors text-center"
                        onClick={() => setIsOpen(false)}
                      >
                        Inicia Sesion
                      </Link>

                      <Link 
                        to="/login?mode=register"
                        className="bg-[#ff681f] text-white font-semibold rounded-full px-6 py-3 text-center hover:bg-[#e05510] transition-colors w-full max-w-xs"
                        onClick={() => setIsOpen(false)}
                      >
                        Registrate
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
    </nav>
  );
}

export default Navbar;